var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpenLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4721 0.5H9.65555C9.36412 0.5 9.12793 0.736195 9.12793 1.02765C9.12793 1.31908 9.36412 1.55528 9.65555 1.55528H12.9445V4.84421C12.9445 5.13564 13.1807 5.37184 13.4721 5.37184C13.7635 5.37184 13.9997 5.13564 13.9997 4.84421V1.02765C13.9997 0.736195 13.7635 0.5 13.4721 0.5Z",
    fill: "#98B1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8453 0.654593C13.6392 0.448449 13.3054 0.448449 13.0993 0.654593L5.5716 8.18222C5.36546 8.38817 5.36546 8.72234 5.5716 8.92829C5.6745 9.03135 5.80957 9.08289 5.94465 9.08289C6.07954 9.08289 6.21462 9.03135 6.3177 8.92829L13.8453 1.40067C14.0515 1.19471 14.0515 0.860546 13.8453 0.654593Z",
    fill: "#98B1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6784 7.06032C11.387 7.06032 11.1508 7.29651 11.1508 7.58794V13.4447H1.05528V3.34925H6.91206C7.20349 3.34925 7.43969 3.11306 7.43969 2.82163C7.43969 2.5302 7.20349 2.29398 6.91206 2.29398H0.527652C0.236195 2.29398 0 2.53017 0 2.82163V13.9724C0 14.2638 0.236195 14.5 0.527652 14.5H11.6784C11.97 14.5 12.206 14.2638 12.206 13.9724V7.58794C12.206 7.29651 11.9698 7.06032 11.6784 7.06032Z",
    fill: "#98B1F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenLink);
export default __webpack_public_path__ + "static/media/icon-open-link.616afee7.svg";
export { ForwardRef as ReactComponent };